module.exports = __webpack_public_path__ + "static/media/stvcard.7450c51b.jpg";